import React from "react";

import buildTextInputDefinition, {
    TextInputDefinition
} from "../../../../../../../utils/forms/models/grid-fields/text-input-definition";

import buildSelectMenuDefinition, {
    SelectMenuDefinition
} from "../../../../../../../utils/forms/models/grid-fields/select-menu-definition";
import buildSwitchDefinition, {
    SwitchDefinition
} from "../../../../../../../utils/forms/models/grid-fields/switch-definition";
import { FormDefinition } from "../../../../../../../utils/forms/builders/build-form-grid-fields";

export const CONFIGURATION_TITLE = "Megapot";

export enum SCHEMA_NAMES {
    ENABLED = "enabled",
    PROVIDER = "provider",
    SERVER = "server",
    ADDRESS = "address"
}

export const MEGAPOT_NAMES = {
    [SCHEMA_NAMES.ENABLED]: "Enabled",
    [SCHEMA_NAMES.PROVIDER]: "Server List Provider",
    [SCHEMA_NAMES.SERVER]: "Server",
    [SCHEMA_NAMES.ADDRESS]: " IP Address / URL"
};

const ENABLED: SwitchDefinition = buildSwitchDefinition({
    name: SCHEMA_NAMES.ENABLED,
    id: SCHEMA_NAMES.ENABLED,
    label: MEGAPOT_NAMES[SCHEMA_NAMES.ENABLED],
    schemaName: SCHEMA_NAMES.ENABLED
});

const PROVIDER = (megapotProviders: any[]): SelectMenuDefinition => {
    let items = []
    megapotProviders.map(provider=>items.push({value: provider.idProvider, label: provider.name}))
    return buildSelectMenuDefinition({
        name: SCHEMA_NAMES.PROVIDER,
        id: SCHEMA_NAMES.PROVIDER,
        noValueLabel: "Select an option...",
        label: MEGAPOT_NAMES[SCHEMA_NAMES.PROVIDER],
        items: items,
        schemaName: SCHEMA_NAMES.PROVIDER
    })
};

const SERVER = (megapotServers: any[]): SelectMenuDefinition => {
    let items = []
    megapotServers.map(server=>items.push({value: server.idServer, label: server.name+' ('+server.idServer+')'}))
    return buildSelectMenuDefinition({
        name: SCHEMA_NAMES.SERVER,
        id: SCHEMA_NAMES.SERVER,
        noValueLabel: "Select an option...",
        label: MEGAPOT_NAMES[SCHEMA_NAMES.SERVER],
        items: items,
        schemaName: SCHEMA_NAMES.SERVER
    })
};

const ADDRESS: TextInputDefinition = buildTextInputDefinition({
    name: SCHEMA_NAMES.ADDRESS,
    id: SCHEMA_NAMES.ADDRESS,
    placeholder: MEGAPOT_NAMES[SCHEMA_NAMES.ADDRESS],
    label: MEGAPOT_NAMES[SCHEMA_NAMES.ADDRESS],
    schemaName: SCHEMA_NAMES.ADDRESS
});


export const MEGAPOT_FORM_DEFINITION: (
    megapotProviders: any[],
    megapotServers: any[],
    form_values: any
) => FormDefinition = (
    megapotProviders: any[],
    megapotServers,
    form_values
) => {
    let fields = {
            [SCHEMA_NAMES.ENABLED]: {
                definition: {
                    ...ENABLED,
                    fieldOverrides: {
                        formSpacing: false,
                        columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    }
                },
                order: 0
            }
        }
    if (form_values && form_values["enabled"] != undefined && form_values["enabled"] == true) {
        fields[SCHEMA_NAMES.PROVIDER] =
            {
                definition:
                    {
                        ...PROVIDER(megapotProviders),
                        fieldOverrides:
                            {
                                formSpacing: false,
                                columnClass: "col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-5"
                            }
                    },
                order: 1
            };
        fields[SCHEMA_NAMES.SERVER] =
            {
                definition:
                    {
                        ...SERVER(megapotServers),
                        fieldOverrides:
                            {
                                formSpacing: false,
                                columnClass: "col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-5"
                            }
                    },
                order: 2
            };
        fields[SCHEMA_NAMES.ADDRESS] =
            {
                definition:
                    {
                        ...ADDRESS,
                        fieldOverrides:
                            {
                                formSpacing: false,
                                columnClass: "col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-5"
                            }
                    },
                order: 3
            };
    }

    return fields;
};
